import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface ISaveOvertimeAlerts {
  id?: string;
  name: string; // required
  overtime_type: string; // optional default weekly
  is_before: boolean; // required
  before_after_overtime: number; // required numeric
  send_notification_by_mail: boolean; // optional
  send_notification_by_push: boolean; //optional
  user_ids: Array<number>; // array of user_ids
  group_ids?: '';
}

const saveOvertimeAlerts = ({ id, ...postData }: ISaveOvertimeAlerts) => {
  if (id) {
    const updatedEndpoints = endpoints.companySettings.updateNotificationSetting.replace('{notificationId}', id);
    return http().put(updatedEndpoints, postData);
  } else return http().post(endpoints.companySettings.advancedNotificationSettings, postData);
};

export function useSaveOvertimeAlerts() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveOvertimeAlerts,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['fetchOvertimeAlerts'] });
    },
  });
}
